import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/authContext';

// Collector V2 connect (DEV). Opened by the extension through chrome.identity.launchWebAuthFlow. The user's normal
// session authorizes a one-time PKCE code that only the registered extension's chromiumapp.org redirect can receive.
// The session token itself never leaves this page. Collector access is decided server-side (403 when not granted).
export default function CollectorConnect() {
  const { accessToken } = useAuth();
  const location = useLocation();
  const [status, setStatus] = useState('Connecting Collector…');
  const [denied, setDenied] = useState(false);
  useEffect(() => {
    if (!accessToken) return;
    const p = new URLSearchParams(location.search);
    const extensionId = p.get('extension_id') || '';
    void (async () => {
      try {
        const r = await fetch('/api/collector/v2/auth/authorize', {
          method: 'POST', credentials: 'omit', cache: 'no-store',
          headers: { Authorization: `Bearer ${accessToken}`, 'Content-Type': 'application/json' },
          body: JSON.stringify({ extension_id: extensionId, redirect_uri: p.get('redirect_uri'), code_challenge: p.get('code_challenge'), code_challenge_method: 'S256', state: p.get('state') }),
        });
        const value = await r.json().catch(() => ({}));
        if (r.status === 403 && value.detail === 'Collector access required') {
          setDenied(true); setStatus('Collector access required');
          // Tell the extension (OAuth-style error) so it shows "Collector access required" instead of waiting.
          const redirect = p.get('redirect_uri') || '';
          if (redirect === `https://${extensionId}.chromiumapp.org/collector-v2`) window.location.replace(`${redirect}#${new URLSearchParams({ error: 'access_denied', state: p.get('state') || '' })}`);
          return;
        }
        if (r.status === 401) { setStatus('ArtistAscend login required'); return; }
        if (!r.ok) throw Error(typeof value.detail === 'string' ? value.detail : 'Collector connection failed');
        const target = new URL(value.redirect);
        if (target.origin !== `https://${extensionId}.chromiumapp.org` || target.pathname !== '/collector-v2') throw Error('Invalid Collector redirect');
        window.location.replace(target.href);
      } catch (e) { setStatus((e as Error).message); }
    })();
  }, [accessToken, location.search]);
  return <main style={{ maxWidth: 480, margin: '48px auto', padding: 24, font: '14px/1.4 system-ui, sans-serif' }}>
    <h1 style={{ fontSize: 18 }}>ArtistAscend Collector</h1>
    {!accessToken ? <>
      <p>ArtistAscend login required</p>
      <p><Link to="/login" state={{ from: location }}>Sign in to ArtistAscend</Link></p>
    </> : <p role="status">{status}</p>}
    {denied && <p>This account is signed in but has not been granted Collector access.</p>}
  </main>;
}
